import * as t from 'io-ts';

const EmailCodec = t.type({
    email: t.string,
});

const ContactsCodec = t.type({
    general: EmailCodec,
});

export const AccountsDetailsCodec = t.type({
    name: t.string,
    contacts: ContactsCodec,
});

export type ApiAccountsDetails = t.TypeOf<typeof AccountsDetailsCodec>;
